import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import i18n from 'i18n-js';
import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { BaseModal } from 'components/UI';
import { Formik, Form, Field } from 'formik';
import { usersActions } from 'state/modules/users';
import { UserGroupsRolesSelect } from 'components/DataFields';

const ChangeUserRoleModal = ({ id, open, role, handleClick }) => {
  const formRef = useRef(null);
  const dispatch = useDispatch();

  const { fetchingChangeUserRole, fetchedChangeUserRoleSuccess } = useSelector(
    (state) => state.users
  );

  const ChangeUserRoleSchema = Yup.object().shape({
    role: Yup.string().required(i18n.t('common.required_field')),
  });

  useEffect(() => {
    if (fetchedChangeUserRoleSuccess) {
      handleClick();
      dispatch(usersActions.resetChangeUserRole());
    }
  }, [fetchedChangeUserRoleSuccess, handleClick, dispatch]);

  /**
   * Function to be executed after form validation
   * @param {object} values Payload to create user
   */
  const onSubmit = (values) => {
    dispatch(usersActions.fetchUpdateUserRole(id, values));
  };

  /**
   * Handle form submit
   */
  const handleSubmit = () => {
    formRef.current.submitForm();
  };

  return (
    <BaseModal
      open={open}
      maxWidth={440}
      hasEnterButton
      hasCancelButton
      onEnter={handleSubmit}
      onCancel={handleClick}
      enableCloseButton={false}
      loading={fetchingChangeUserRole}
      title={i18n.t('users.change_role')}
      enterButtonLabel={i18n.t('common.change')}
    >
      <Formik
        innerRef={formRef}
        onSubmit={onSubmit}
        initialValues={{ role }}
        validationSchema={ChangeUserRoleSchema}
      >
        {({ handleSubmit, errors }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Box mt={1}>
              <Field
                name="role"
                margin="none"
                asyncErrors={errors?.role}
                label={i18n.t('users.role')}
                component={UserGroupsRolesSelect}
              />
            </Box>
          </Form>
        )}
      </Formik>
    </BaseModal>
  );
};

ChangeUserRoleModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
};

ChangeUserRoleModal.defaultProps = {
  open: false,
  handleClick: () => {},
};

export default ChangeUserRoleModal;
